module.exports = __webpack_public_path__ + "static/media/initiative-speech.dee42d42.svg";